<template>
  <div class="w-full height-100">
    <div class="seth-set bg-primary">
      <div class="absolute top-0 py-10 w-full px-6 flex">
        <div class="">
          <p
            @click="handleBack"
            class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
          >
            <feather-icon icon="ArrowLeftIcon" svgClasses="w-6 h-6" />
            Go Back
          </p>
          <h2 class="text-white pt-1 text-2xl capitalize font-semibold">
            Performance Logs
          </h2>
        </div>
      </div>
    </div>

    <div class="fixed-top bg-white p-6">
      <div class="">
        <el-table
          :data="tableData"
          border
          style="width: 100%"
          height="490"
          class="table-responsive table-flush mt-6 cust-overflow-x-primary-color"
          header-row-class-name="thead-light table-th-colorpd"
        >
          <el-table-column
            prop="description"
            label="Description"
            min-width="200px"
          >
            <template slot-scope="">
              <P class="text-gray">ABCD</P>
            </template>
          </el-table-column>

          <el-table-column
            prop="createdat"
            label="Created at"
            min-width="200px"
          >
            <template slot-scope="">
              <P class="text-gray">10/12/2022</P>
            </template>
          </el-table-column>
        </el-table>
        <div class="w-full flex justify-end mt-6">
          <el-pagination pills :total-rows="rows" size="sm"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      drawer: false,
      direction: "rtl",
      subcategoryoptions: [
        {
          value: "HTML",
          label: "HTML",
        },
        {
          value: "CSS",
          label: "CSS",
        },
        {
          value: "JavaScript",
          label: "JavaScript",
        },
      ],
      tableData: [
        {
          date: "20 December 2019",
          name: "Tom",
          state: "PR-1",
          city: "Active",
          address: "No. 189, Grove St, Los Angeles",
          zip: "CA 90036",
        },
        {
          date: "20 December 2019",
          name: "Tom",
          state: "PR-1",
          city: "Active",
          address: "No. 189, Grove St, Los Angeles",
          zip: "CA 90036",
        },
        {
          date: "20 December 2019",
          name: "Tom",
          state: "PR-1",
          city: "Active",
          address: "No. 189, Grove St, Los Angeles",
          zip: "CA 90036",
        },
        {
          date: "20 December 2019",
          name: "Tom",
          state: "PR-1",
          city: "Active",
          address: "No. 189, Grove St, Los Angeles",
          zip: "CA 90036",
        },
        {
          date: "20 December 2019",
          name: "Tom",
          state: "PR-1",
          city: "Active",
          address: "No. 189, Grove St, Los Angeles",
          zip: "CA 90036",
        },
        {
          date: "20 December 2019",
          name: "Tom",
          state: "PR-1",
          city: "",
          address: "No. 189, Grove St, Los Angeles",
          zip: "CA 90036",
        },
        {
          date: "20 December 2019",
          name: "Tom",
          state: "PR-1",
          city: "Active",
          address: "No. 189, Grove St, Los Angeles",
          zip: "CA 90036",
        },
      ],
    };
  },
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>
